import { themeBackgrounds, themeColors } from "@dana/MobiusOverrides/styles/colors";
import { getResponsiveSpacing } from "@dana/MobiusOverrides/styles/spacing";
import { lineHeights } from "@dana/MobiusOverrides/styles/typography";
import { specificationsStyles } from "@dana/Overrides/Widgets/ProductDetails/ProductDetailsSpecifications";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { AccordionSectionHeader, AccordionSectionPanel } from "@insite/mobius/AccordionSection";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

specificationsStyles.specificationsAccordion = mergeToNew(specificationsStyles.specificationsAccordion, {
    mergeCss: true,
    css: css`
        max-width: 1440px;
        margin: 0 auto;

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        padding: 0 16px;
                    `,
                    css`
                        padding: 0 16px;
                    `,
                    css`
                        padding: 0 24px;
                    `,
                    css`
                        padding: 0 40px;
                    `,
                ],
                "min",
            )}

        ${AccordionSectionPanel} + ${AccordionSectionHeader} {
            button {
                border-top: 1px solid ${themeBackgrounds.lightGray};

                &:focus {
                    border-color: ${themeColors.primary.white};
                    padding-top: 16px;
                }
            }
        }
    `,
});

specificationsStyles.specificationsAccordionSection = mergeToNew(specificationsStyles.specificationsAccordionSection, {
    headerProps: {
        css: css`
            margin-bottom: 16px;
        `,
    },
    panelProps: {
        css: css`
            padding: 24px;
            background: ${themeColors.primary.white};

            &:not([hidden]) {
                margin-bottom: 16px;
                margin-top: -16px;
                @media print {
                    margin: 0 0 8px;
                }
            }

           
        `,
    },
});

specificationsStyles.attributeTypeLabelText = mergeToNew(specificationsStyles.attributeTypeLabelText, {
    weight: "normal",
    lineHeights: lineHeights.defaultLarge,
    css: css`
        border-right: 1px solid ${themeBackgrounds.lightGray};
        padding: 8px 0;
        height: 100%;
        @media print {
            padding: 2px 0;
        }
    `,
});

specificationsStyles.attributeTypeValuesText = mergeToNew(specificationsStyles.attributeTypeValuesText, {
    weight: "normal",
    lineHeights: lineHeights.defaultLarge,
    css: css`
        padding: 8px 0;
        height: 100%;
        @media print {
            padding: 2px 0;
        }
    `,
});

specificationsStyles.attributeTypeWrapper = mergeToNew(specificationsStyles.attributeTypeWrapper, {
    lineHeights: lineHeights.defaultLarge,
    css: css`
        padding: 0 8px;
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 8px;
        align-items: flex-start;
        margin-bottom: 0;
        width: auto;
        border: 1px solid ${themeBackgrounds.lightGray};
        padding-bottom: 0;

        &:not(:last-child) {
            border-bottom: none;
        }

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        grid-template-columns: 300px 1fr;
                    `,
                    css`
                        grid-template-columns: 300px 1fr;
                    `,
                ],
                "min",
            )}
    `,
});

specificationsStyles.specsDiagramWrapper = mergeToNew(specificationsStyles.specsDiagramWrapper, {
    css: css`
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        width: 100%;
        gap: 24px;

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        flex-direction: row;
                    `,
                    css`
                        flex-direction: row;
                    `,
                ],
                "min",
            )}

        .product-attributes-container {
            width: 100%;
            flex-grow: 1;
        }
    `,
});

specificationsStyles.modelDiagramContainer = mergeToNew(specificationsStyles.modelDiagramContainer, {
    css: css`
        width: 100%;
        min-width: 50%;
    `,
});
